module.exports = __webpack_public_path__ + "static/media/smile-plus.ce33c0b6.svg";